module.exports = __webpack_public_path__ + "img/megane-rezultati.36ccaf76.jpg";